import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';


@Component({
	selector: 'common-message',
	imports: [CommonModule],
	templateUrl: './common-message.widget.html',
	styleUrls:['./common-message.widget.scss'],
})
export class CommonMessageWidget {

	public alertType = input<'info' | 'success' | 'warning' | 'error' | 'locked'>('info');
	public closeable = input<boolean>(false);

	public closed = false;
}
